<template>
    <div class="values-pendencies">
        <div v-for="(pendency, index) in pendingEvaluations" :key="index" class="pendency">
            <img src="@/assets/icons/values-pendency.svg" />
            <span
                >{{ $t('values.theEvaluation') }}
                <b>"{{ pendency.questionnaire.title }}"</b>
                {{ $t('values.availableEvaluation') }}
                <router-link class="link" to="/v2/values/evaluations">{{ $t('values.accessHere') }}</router-link></span
            >
        </div>
    </div>
</template>
<script>
export default {
    props: {
        pendingEvaluations: {
            type: Array,
            required: true,
        },
    },
}
</script>
<style lang="sass" scoped>
.values-pendencies
    display: flex
    flex-direction: column
    gap: .5rem
    .pendency
        display: flex
        gap: .5rem
        padding: 0.8rem
        border: 1px solid #BEC0C0
        box-sizing: border-box
        border-radius: 5px
        font-family: 'Roboto'
        font-style: normal
        font-weight: 400
        font-size: 1rem
        line-height: 19px
        display: flex
        align-items: center
        color: #3B3F4E
        .link
            font-weight: 700
            color: #009ADA
</style>
